import React from 'react';
import {Radio} from 'elements';

const RadioTextCell = ({data, color, label, onClick, className}) => {
  return (
    <td className={`pi-type-checkbox-text ${className ? className : ''}`}>
      <div className='pi-td'>
        <Radio color={color} checked={data.checked} onChange={() => onClick(data)} />
        <span onClick={() => onClick(data, true)}>{label}</span>
      </div>
    </td>
  );
};

export default RadioTextCell;
